import styled from 'styled-components';
import { MainTitle } from '@src/theme/commonElements';
export const Title = styled(MainTitle) `
  margin-bottom: -6px;
`;
